
export default {
  functional: true,

  render (createElement: any, props: any) {
    // console.log(createElement)
    // console.log(props)
    const val = props.data.attrs.val

    const e1 = createElement('div', {
      attrs: { class: 'sp1 b' },
      domProps: {
        innerHTML: val.d
      }
    })
    const e2 = createElement('div', {
      attrs: {
        class: 'clsPosition'
      },
      domProps: {
        innerHTML: val.b
      }
    })
    const e3 = createElement('div', {
      attrs: {
        class: 'clsDescription'
      },
      domProps: {
        innerHTML: val.t
      }
    })
    return [e1, e2, e3]
  }
}
